// frontend/src/components/layout/Row.tsx
import React, { CSSProperties, ReactNode } from 'react';

type Position = 'center' | 'split' | 'full';

interface RowProps {
  children: ReactNode;
  position: Position;
  custom_css?: CSSProperties;
  start?: ReactNode; // For 'split' position
  end?: ReactNode;   // For 'split' position
}

const Row: React.FC<RowProps> = ({ children, position, custom_css, start, end }) => {
  const getStyleForPosition = (): CSSProperties => {
    switch (position) {
      case 'center':
        return {
          gridColumn: '2 / 3',
        };
      case 'split':
        return {
          gridColumn: '1 / 4',
          display: 'flex',
          justifyContent: 'space-between',
        };
      case 'full':
        return {
            gridColumn: '1 / 4'
        }
      default:
        return {};
    }
  };

  return (
    <div style={{ ...getStyleForPosition(), ...custom_css }}>
      {position === 'split' ? (
        <>
          <div>{start}</div>
          <div>{end}</div>
        </>
      ) : (
        children
      )}
    </div>
  );
};

export default Row;
